import React from 'react';

function PostAuthor(props) {
    const {
        post
    } = props;

    const show_author  = post.acf.show_author;
    const post_date = new Date(post.date);
    let thumb;
    let role;
    let name;
    let date;

    if ( post.author_meta.thumb ) {
        thumb = <figure className='post-author__thumb' dangerouslySetInnerHTML={{__html: post.author_meta.thumb}}></figure>
    }

    if ( post.author_meta.role ) {
        role = <p className='post-author__role'>{post.author_meta.role}</p>
    }

    if ( post.author_meta.name ) {
        name = <h2 className='post-author__name'>{post.author_meta.name}</h2>
    }

    date = `${post_date.getMonth() + 1}/${post_date.getDate()}/${post_date.getFullYear()}`;

    if ( show_author ) {
        return (
            <div className="post-author">
            {thumb}
            <div className="post-author__details">
                {name}
                {role}
            </div>
        </div>
        )
    } else {
        return (
            <div className="post-date">{date}</div>
        )
    }
}

export default PostAuthor;
